/* Fiber Reco Attribution v1.1.1 — origem do add-to-cart + funil dos widgets.

   Como funciona: cada widget marca seu container com data-reco-source="<slug>". Este script
   injeta `properties[_reco_source]` nos formulários de /cart/add que estão dentro desse
   container — inclusive nos cards renderizados por JS depois do load (drawer, recomendados,
   complementares) e no quick-buy modal aberto a partir de um card do widget.

   A property com prefixo "_" é oculta ao cliente e fica salva no pedido (line_items[].properties),
   que é o que o worker do painel lê para atribuir receita por mecanismo.

   Para os widgets que adicionam via fetch('/cart/add.js'), use o helper:
     window.FiberReco.withSource(items, 'slug')  ->  items com properties._reco_source

   v1.1.1 — funil: conta impressão (IntersectionObserver, 1x por widget por
   pageview), clique e add, e manda em lote para o painel via sendBeacon (não
   bloqueia navegação). Sem PII: a sessão é um id aleatório em sessionStorage.
   Holdout: bucket determinístico por sessão; HOLDOUT_PCT=0 mantém todos vendo o
   widget — subir esse número é decisão comercial, não técnica.
*/
(function () {
  'use strict';

  var SOURCE_ATTR = 'data-reco-source';
  var FIELD = 'properties[_reco_source]';
  var BUCKET_FIELD = 'properties[_reco_bucket]';
  var SELECTOR = 'form[action*="/cart/add"]';
  var quickBuyPending = null; // origem do card que abriu o quick-buy modal

  function sourceOf(el) {
    if (!el || !el.closest) return null;
    var holder = el.closest('[' + SOURCE_ATTR + ']');
    return holder ? (holder.getAttribute(SOURCE_ATTR) || null) : null;
  }

  // bucket do holdout (etapa de incrementalidade); só acompanha, não decide render
  function bucket() {
    try {
      return window.FiberReco && window.FiberReco.bucket ? window.FiberReco.bucket() : null;
    } catch (e) {
      return null;
    }
  }

  function setHidden(form, name, value) {
    if (!value) return;
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function tag(form, source) {
    if (!form || !source) return;
    setHidden(form, FIELD, source);
    setHidden(form, BUCKET_FIELD, bucket());
  }

  // 1) varredura: pega forms que já existem e os inseridos por JS depois
  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll('[' + SOURCE_ATTR + '] ' + SELECTOR);
    for (var i = 0; i < forms.length; i++) tag(forms[i], sourceOf(forms[i]));
  }

  // 2) rede de segurança: se o form nasceu e submeteu no mesmo tick, marca no caminho
  function onSubmitCapture(ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    var source = sourceOf(form);
    if (!source && quickBuyPending && form.closest('quick-buy-modal')) source = quickBuyPending;
    tag(form, source);
    if (source) track('add', { widget: source, product_id: productIdOf(form) });
  }

  // 3) quick-buy modal: o form usado é o da PDP, fora do container do widget —
  //    guarda a origem do card no clique que abre o modal.
  function onClickCapture(ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var opener = target.closest('[aria-controls^="product-quick-buy"]');
    if (!opener) return;
    quickBuyPending = sourceOf(opener);
  }

  /* ================= FUNIL + HOLDOUT ================= */
  var EVENTS_URL = 'https://painelfiber.rafaeltondin.com.br/api/public/widget-events';
  var SESSION_KEY = 'fiber_reco_sid';
  var BUCKET_KEY = 'fiber_reco_bucket';
  var HOLDOUT_PCT = 0; // 0 = ninguém no holdout. Ex.: 10 => 10% sem widget.
  var queue = [];
  var flushTimer = null;
  var seenImpressions = {};

  function sessionId() {
    try {
      var id = sessionStorage.getItem(SESSION_KEY);
      if (!id) {
        var bytes = new Uint8Array(20);
        (window.crypto || window.msCrypto).getRandomValues(bytes);
        id = Array.prototype.map.call(bytes, function (b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
        sessionStorage.setItem(SESSION_KEY, id);
      }
      return id;
    } catch (e) {
      return null;
    }
  }

  // bucket estável por sessão (mesma sessão => mesmo bucket sempre)
  function bucket() {
    if (!HOLDOUT_PCT) return 'on';
    try {
      var b = sessionStorage.getItem(BUCKET_KEY);
      if (b === 'on' || b === 'off') return b;
      var id = sessionId() || '';
      var n = parseInt(id.slice(0, 4) || '0', 16) % 100;
      b = n < HOLDOUT_PCT ? 'off' : 'on';
      sessionStorage.setItem(BUCKET_KEY, b);
      return b;
    } catch (e) {
      return 'on';
    }
  }

  function flush() {
    flushTimer = null;
    if (!queue.length) return;
    var payload = JSON.stringify({ events: queue.splice(0, 20) });
    try {
      if (navigator.sendBeacon) {
        // text/plain = requisição "simples": sem preflight, que o beacon não faz
        navigator.sendBeacon(EVENTS_URL, new Blob([payload], { type: 'text/plain;charset=UTF-8' }));
        return;
      }
    } catch (e) { /* cai no fetch */ }
    try {
      fetch(EVENTS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
        mode: 'cors',
      }).catch(function () {});
    } catch (e) { /* telemetria nunca quebra a loja */ }
  }

  function track(type, data) {
    var ev = data || {};
    queue.push({
      type: type,
      widget: ev.widget || ev.source || null,
      product_id: ev.product_id || null,
      anchor_id: ev.anchor_id || null,
      session_hash: sessionId(),
      bucket: bucket(),
    });
    if (queue.length >= 10) return flush();
    if (!flushTimer) flushTimer = setTimeout(flush, 2000);
  }

  function productIdOf(el) {
    var form = el.closest ? el.closest('form') : null;
    var input = form && form.querySelector('input[name="product-id"], input[name="id"]');
    return input ? Number(input.value) || null : null;
  }

  // impressão: 1 por widget por pageview, quando 40% do container aparece
  function watchImpressions() {
    if (!window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var source = entry.target.getAttribute(SOURCE_ATTR);
        if (!source || seenImpressions[source]) return;
        seenImpressions[source] = true;
        track('impression', { widget: source });
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    document.querySelectorAll('[' + SOURCE_ATTR + ']').forEach(function (el) {
      if (el.dataset.fiberImpWatch) return;
      el.dataset.fiberImpWatch = '1';
      io.observe(el);
    });
  }

  // clique em qualquer CTA dentro de um widget marcado
  function onClickTrack(ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var cta = target.closest('button, a');
    if (!cta) return;
    var source = sourceOf(cta);
    if (!source) return;
    track('click', { widget: source, product_id: productIdOf(cta) });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });

  function start() {
    scan(document);
    watchImpressions();

    document.addEventListener('submit', onSubmitCapture, true);
    document.addEventListener('click', onClickCapture, true);
    document.addEventListener('click', onClickTrack, true);

    // setTimeout (nao requestAnimationFrame): rAF nao dispara com a aba em background,
    // e cards de widget entram por AJAX — a marcacao nao pode esperar o foco da aba.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        scan(document);
        watchImpressions();
      }, 0);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // API para os widgets que adicionam por fetch('/cart/add.js')
  var api = {
    sourceOf: sourceOf,
    tagForm: tag,
    track: track,
    bucket: bucket,
    flush: flush,
    withSource: function (items, source) {
      var b = bucket();
      return (items || []).map(function (item) {
        var props = {};
        if (item.properties) {
          for (var k in item.properties) {
            if (Object.prototype.hasOwnProperty.call(item.properties, k)) props[k] = item.properties[k];
          }
        }
        if (source) props._reco_source = source;
        if (b) props._reco_bucket = b;
        item.properties = props;
        return item;
      });
    }
  };

  window.FiberReco = window.FiberReco ? Object.assign(window.FiberReco, api) : api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
